<router-outlet></router-outlet>
<ngx-spinner></ngx-spinner>


<div class="ambiente" *ngIf="!ambiente">DESENVOLVIMENTO</div>
<div class="ambiente" *ngIf="ambiente">PRODUCAO</div>
